import { Trans } from 'react-i18next';

import {
    Body1,
    IconTile,
    List,
    ListItem,
    getIconByName,
} from '@myphx-engineering/phx-design-system';

import type { NdcPathwaySwitchConfig } from '../../../../types/drug-config';

export const BulletSection = ({
    bullets,
}: {
    bullets: Required<
        NdcPathwaySwitchConfig['content']['details']['whatYouGet']
    >['bullets'];
}) => {
    return (
        <List>
            {bullets.map((bullet) => {
                const Icon = getIconByName(bullet.icon);

                return (
                    <ListItem
                        key={bullet.key}
                        icon={
                            <IconTile
                                color={bullet.iconColor}
                                shape="circle"
                                size="xs"
                                Icon={Icon}
                            />
                        }
                    >
                        <Body1>
                            <Trans ns="dynamic" components={{ b: <strong /> }}>
                                {bullet.content}
                            </Trans>
                        </Body1>
                    </ListItem>
                );
            })}
        </List>
    );
};
